namespace $ {

	$mol_style_define( $bog_ui_app_toast, {

		padding: $mol_gap.block,

		Description: {
			color: $mol_theme.shade,
			padding: {
				bottom: '1rem',
			},
		},

		Buttons_title: {
			font: {
				size: '1.125rem',
				weight: 'bold',
			},
			padding: {
				top: '.5rem',
				bottom: '.75rem',
			},
		},

		Buttons: {
			display: 'flex',
			gap: '.75rem',
			flex: {
				wrap: 'wrap',
			},
			padding: {
				bottom: '1rem',
			},
		},

	} )

}
